import { TFunction } from 'i18next'

import { BadgeColorKeys } from '@/components/ui/badge'
import { PackageStatus, PackageStatusSchema } from '@/models'

const PACKAGE_STATUS_COLOR_MAP: Record<PackageStatus, BadgeColorKeys> = {
  Archived: 'neutral',
  Pending: 'green',
  Received: 'neutral',
  Requested: 'orange',
}

export const getPackageBadgeColor = (status: PackageStatus): BadgeColorKeys => {
  return PACKAGE_STATUS_COLOR_MAP[status] ?? 'neutral'
}

export const getPackageStatusLabels = (
  t: TFunction<['packages']>,
): Record<PackageStatus, string> => ({
  [PackageStatusSchema.enum.Archived]: t('packages:status.archived'),
  [PackageStatusSchema.enum.Pending]: t('packages:status.pending'),
  [PackageStatusSchema.enum.Received]: t('packages:status.received'),
  [PackageStatusSchema.enum.Requested]: t('packages:status.requested'),
})
